type ExperimentParameters = Record<string, string>;
export type ExperimentDefinition = readonly [string, ExperimentParameters];
export type ExperimentDefinitions = Record<string, ExperimentDefinition>;

export const ExperimentLayers = {
  Measures: [
    'telehealth_measures',
    {
      ShouldShowClientMeasures: 'shouldShowClientMeasures',
      ShouldShowProviderMeasures: 'shouldShowProviderMeasures',
    },
  ],
  PruneGraceMultiplier: [
    'telehealth_prune_grace_multiplier_experiment',
    {
      pruneGraceMultiplier: 'pruneGraceMultiplier',
    },
  ],
  SoftBlock: [
    'telehealth_softblock',
    {
      IsEnabled: 'soft_block_is_enabled',
    },
  ],
  Admission: [
    'telehealth_admission',
    {
      automaticAdmissionIsEnabled: 'automaticAdmissionIsEnabled',
    },
  ],
} as const satisfies ExperimentDefinitions;
